import React from 'react';

import {ConfirmPopover} from 'app/general/widgets/ConfirmPopover';
import {useDeleteTeam} from 'app/teams/api';
import {gt} from 'app/utils/i18n';

import type {TeamSerializedType} from 'sweet-types';

interface Props {
  teamDeletedCallback?: () => void;
  team: TeamSerializedType;
}

export function DeleteTeamButton({
  team,
  teamDeletedCallback,
}: Props): JSX.Element {
  const [isBusy, setIsBusy] = React.useState(false);
  const [deleteTeam] = useDeleteTeam();

  const performDelete = () => {
    setIsBusy(true);
    return deleteTeam({id: team.id, name: team.name})
      .unwrap()
      .then(
        () => teamDeletedCallback?.(),
        () => setIsBusy(false)
      );
  };

  return (
    <ConfirmPopover
      placement="left"
      confirmText={gt('Yes, delete Team')}
      onConfirm={performDelete}
      isIdle={!isBusy}
      busyText={gt('Deleting Team...')}
    >
      {(handlers) => (
        <button
          {...handlers}
          className="btn btn-link btn-sm px-2 py-1 text-danger"
          title={gt('Delete Team')}
        >
          <i className="far fa-fw fa-trash" />
        </button>
      )}
    </ConfirmPopover>
  );
}
